export default [
    {
        value: {
            value: 'NATURA',
            id: 'Natura'
        },
        label: 'Natura',
    }, {
        value: {
            value: 'AVON',
            id: 'Avon' // REVISAR SI ES EL ID CORRECTO!!
        },
        label: 'Avon',
    }
];
